import { useEffect, useState } from 'react';

import {
  getProductDocumentation,
  ProductDocumentation,
} from 'api/documentation';

// The docs page and the follow-along panel share one download per page load.
let cached: Promise<ProductDocumentation> | undefined;

const loadDocumentation = () => {
  if (!cached)
    cached = getProductDocumentation().catch(error => {
      // A later mount retries instead of keeping the failure.
      cached = undefined;
      throw error;
    });
  return cached;
};

/** The product documentation, or an error flag if it couldn't be loaded. */
export const useProductDocumentation = (enabled = true) => {
  const [documentation, setDocumentation] = useState<ProductDocumentation>();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    setError(false);
    loadDocumentation()
      .then(result => active && setDocumentation(result))
      .catch(() => active && setError(true));
    return () => {
      active = false;
    };
  }, [enabled]);

  return { documentation, error };
};

/** For tests: forget the loaded documentation. */
export const resetProductDocumentationCache = () => {
  cached = undefined;
};
